import React from "react";
import "./Group79.css";

function Group79() {
  return (
    <div className="group-79">
      <img className="icon-star" src="/img/path-50@1x.png" />
      <div className="x5-per-1-spent avenir-heavy-normal-eerie-black-18px">5% PER $1 SPENT</div>
      <p className="on-personal-referr avenir-book-normal-eerie-black-12px">
        ON PERSONAL &amp; REFERRED FRIEND’S ORDER’S
      </p>
    </div>
  );
}

export default Group79;
